import { FRONT_URL } from "@/shared/config/front-url";

// Экран «Кабинет уже подключён» с кнопкой «Запросить доступ» есть только на сайте
// (SAEX-3262), сюда ведём человека с токеном чужого кабинета.
export const ADD_CABINET_WEB_URL = `${FRONT_URL}/add-cabinet`;

export interface AccessRequiresInvite {
  supplierId: string;
  supplierName: string;
}

const tokenErrorMessagesByCode: Record<string, string> = {
  INVALID_TOKEN: "Токен WB не удалось распарсить",
  TOKEN_PERMISSION_ERROR: "У токена нет необходимых прав доступа",
  PERSONAL_TOKEN_NOT_ALLOWED: "Персональные токены WB не поддерживаются",
};

const defaultTokenAddError = "Ошибка при добавлении токена";

const roleLabels: Record<string, string> = {
  viewer: "Наблюдатель",
  manager: "Менеджер",
  accountant: "Бухгалтер",
  designer: "Дизайнер",
  admin: "Администратор",
};

const asRecord = (value: unknown): Record<string, unknown> | null =>
  value && typeof value === "object" ? (value as Record<string, unknown>) : null;

export const readAccessRequiresInvite = (
  status: number | undefined,
  body: unknown,
): AccessRequiresInvite | null => {
  const error = asRecord(asRecord(body)?.error);
  if (status !== 403 || error?.code !== "ACCESS_REQUIRES_INVITE") return null;
  const data = asRecord(error.data);
  const supplierId = data?.supplier_id;
  if (typeof supplierId !== "string" || !supplierId) return null;
  const supplierName = data?.supplier_name;
  return {
    supplierId,
    supplierName: typeof supplierName === "string" ? supplierName : "",
  };
};

export const tokenAddErrorMessage = (
  status: number | undefined,
  code: string | undefined,
): string =>
  status === 400 && code && Object.hasOwn(tokenErrorMessagesByCode, code)
    ? tokenErrorMessagesByCode[code]
    : defaultTokenAddError;

export const grantedRoleMessage = (role: string): string =>
  `Доступ к кабинету открыт: вы в команде с ролью «${
    Object.hasOwn(roleLabels, role) ? roleLabels[role] : "Сотрудник"
  }». Владелец получит уведомление.`;
